import React, { useEffect } from 'react';
import { CheckCircle2, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useToast } from '../../contexts/ToastContext';

const ICONS = {
  success: CheckCircle2,
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
};

// Cores tipadas: borda lateral, ícone e barra de progresso. Fundo é branco
// sólido (não bg-app-surface) — em alguns temas whitelabel surface vira muito
// claro/translúcido e o toast ficava ilegível sobre texto da página.
const TYPE_STYLES = {
  success: { border: 'border-success', icon: 'text-success', bar: 'bg-success' },
  error: { border: 'border-error', icon: 'text-error', bar: 'bg-error' },
  warning: { border: 'border-warning', icon: 'text-warning', bar: 'bg-warning' },
  info: { border: 'border-info', icon: 'text-info', bar: 'bg-info' },
};

const Toast = ({ toast }) => {
  const { removeToast } = useToast();
  const Icon = ICONS[toast.type] || Info;
  const style = TYPE_STYLES[toast.type] || TYPE_STYLES.info;
  const isAlert = toast.type === 'error' || toast.type === 'warning';
  const duration = toast.duration > 0 ? toast.duration : 0;

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => removeToast(toast.id), duration);
      return () => clearTimeout(timer);
    }
  }, [toast.id, duration, removeToast]);

  return (
    <div
      role={isAlert ? 'alert' : 'status'}
      aria-live={isAlert ? 'assertive' : 'polite'}
      className={`relative overflow-hidden bg-white border border-app-border ${style.border} border-l-4 rounded-lg shadow-2xl p-4 pr-3 flex items-start gap-3 animate-slide-in-up w-full max-w-[500px] cursor-pointer transition-shadow duration-200 hover:shadow-xl`}
      onClick={() => removeToast(toast.id)}
    >
      <Icon size={20} className={`flex-shrink-0 mt-0.5 ${style.icon}`} />
      <div className="flex-1 min-w-0">
        <div className="font-medium text-sm leading-relaxed whitespace-pre-line text-app-text">
          {toast.message}
        </div>
      </div>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          removeToast(toast.id);
        }}
        className="flex-shrink-0 text-app-text-secondary opacity-70 hover:opacity-100 transition-opacity"
        aria-label="Fechar"
      >
        <X size={16} />
      </button>
      {duration > 0 && (
        <div
          className={`absolute bottom-0 left-0 h-1 w-full ${style.bar} animate-toast-progress`}
          style={{ animationDuration: `${duration}ms` }}
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default Toast;
